import './ReferralHeader.scss'

import React from 'react'

import {
  trackActivity
} from 'manager/redux/referral'

const ReferralContact = (props) => {

  const isLandline = props.referral.phone_type == 'landline'

  const isEmailValid = props.referral.email ? !props.referral.email.match('Declined email') : false

  const handleCall = () => {
    const { canUseVoip, dispatch, referral: { hash, assignment_hash, phone, name } } = props

    dispatch(trackActivity(hash, 'phone'))

    if (canUseVoip) {
      window.ReactNativeWebView.postMessage(`call:${assignment_hash},${phone},${name}`)
    } else {
      window.location = 'tel:' + phone
    }
  }

  const handleSMS = () => {
    const { canUseInbox, dispatch, referral } = props
    const { hash, assignment_hash, phone } = referral
    if (isLandline) {
      window.ReactNativeWebView.postMessage(`sms-failure`)
    } else {
      dispatch(trackActivity(hash, 'sms'))
      if (canUseInbox) {
        window.ReactNativeWebView.postMessage(`inbox:${assignment_hash}`)
      } else {
        window.location = 'sms:' + phone
      }
    }
  }

  const handleEmail = () => {
    props.dispatch(trackActivity(props.referral.hash, 'email'))
    window.location = 'mailto:' + props.referral.email
  }

  return (
    <div>
      <div className="ReferralHeader__action ReferralHeader__action--call clickable" onClick={handleCall}>
        <i className="fa fa-phone" aria-hidden="true"/>
        <div className="ReferralHeader__label">Call</div>
      </div>
      <div className={`ReferralHeader__action ReferralHeader__action--sms${isLandline && '--disabled'} clickable`} onClick={handleSMS}>
        <i className="fa fa-comment" aria-hidden="true"/>
        <div className="ReferralHeader__label">SMS</div>
      </div>
      {isEmailValid && 
      <div className="ReferralHeader__action ReferralHeader__action--email clickable" onClick={handleEmail}>
        <i className="fa fa-envelope" aria-hidden="true"/>
        <div className="ReferralHeader__label">Email</div>
      </div>
      }
    </div>
  )

}

export default ReferralContact
